import { Instagram } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-charcoal text-marble/80 py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <p className="font-serif-lux text-3xl tracking-[0.25em] text-marble mb-4">ALTIUS</p>
            <p className="text-sm font-light leading-relaxed max-w-sm text-marble/60">
              Premium wellness, health and recovery essentials — curated in Australia,
              delivered to your door. Rest is a discipline. We make it beautiful.
            </p>
          </div>
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-gold mb-5">Shop</p>
            <ul className="space-y-3 text-sm font-light">
              <li><a data-testid="footer-shop-link" href="#shop" className="hover:text-gold transition-colors">The Collection</a></li>
              <li><a data-testid="footer-why-link" href="#why" className="hover:text-gold transition-colors">Why Altius</a></li>
              <li><a data-testid="footer-reviews-link" href="#reviews" className="hover:text-gold transition-colors">Reviews</a></li>
            </ul>
          </div>
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-gold mb-5">Follow Us</p>
            <a
              data-testid="footer-instagram-link"
              href="https://www.instagram.com/altiusaus"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 group"
            >
              <span className="w-11 h-11 rounded-full border border-gold/40 flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-charcoal transition-all duration-300">
                <Instagram size={19} strokeWidth={1.75} />
              </span>
              <span className="text-sm font-light text-marble/70 group-hover:text-gold transition-colors">@altiusaus</span>
            </a>
            <p className="text-xs text-marble/40 mt-4 leading-relaxed max-w-[200px]">
              Follow for new drops, recovery tips and behind the scenes.
            </p>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-marble/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-marble/40 tracking-wider">
          <span data-testid="footer-copyright">© 2026 Altius · altiusaud.com</span>
          <span>Premium Wellness & Recovery — Australia</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
